<template>
  <div style="background: #efeff4;">
    <div class="doctor-cell">
      <div class="icon"></div>
      <div class="info">
        <div style="margin-top:20px;">
          <span style="font-weight: bold;font-size:17px;">易艳尔</span>
        </div>
        <div style="margin-top:6px;font-size:15px">口腔科/主任医师</div>
      </div>
    </div>
    <div style="margin-top:9px;">
      <ph-tab :list="[{ name: '专家介绍' }]" />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.doctor-cell {
  display: flex;
  height: 100px;
  margin: 15px 15px 0 15px;
  background-color: white;
  border-radius: 8px;
}
.icon {
  width: 60px;
  min-width: 60px;
  height: 60px;
  margin: 15px 15px 0 15px;
  background-color: violet;
  border-radius: 30px;
}
</style>
